import { CodeSurfer, CodeSurferColumns, Step } from "code-surfer";
import { github, vsDark } from "@code-surfer/themes";
import { Split, SplitRight, Invert } from 'mdx-deck';
import Avatar from "../../../../../../src/IMG_20191205_214533.jpg";
import LogoPSL from "../../../../../../src/logo_psl.png";
import Gato from "../../../../../../src/gato.jpeg";
import GithubProfile from "../../../../../../src/github-profile.png";
import JamStackImage from "../../../../../../src/jamstack.png";
import SeCOrToScreen from "../../../../../../src/secorto/index.png";
import SeCOrToBlogScreen from "../../../../../../src/secorto/blog-post.png";
import PyBaqAbout from "../../../../../../src/pybaq/about-front.png";
import PyBaqAboutAdmin from "../../../../../../src/pybaq/about-admin.png";
import MarkdownOrigen from "../../../../../../src/markdownOrigen.mdx";
import MarkdownDemo1 from "../../../../../../src/markdownDemo1.mdx";
import MarkdownDemo2 from "../../../../../../src/markdownDemo2.mdx";
import MDXDemo from "../../../../../../src/mdx.mdx";
import React from 'react';
export default {
  CodeSurfer: CodeSurfer,
  CodeSurferColumns: CodeSurferColumns,
  Step: Step,
  github: github,
  vsDark: vsDark,
  Split: Split,
  SplitRight: SplitRight,
  Invert: Invert,
  Avatar: Avatar,
  LogoPSL: LogoPSL,
  Gato: Gato,
  GithubProfile: GithubProfile,
  JamStackImage: JamStackImage,
  SeCOrToScreen: SeCOrToScreen,
  SeCOrToBlogScreen: SeCOrToBlogScreen,
  PyBaqAbout: PyBaqAbout,
  PyBaqAboutAdmin: PyBaqAboutAdmin,
  MarkdownOrigen: MarkdownOrigen,
  MarkdownDemo1: MarkdownDemo1,
  MarkdownDemo2: MarkdownDemo2,
  MDXDemo: MDXDemo,
  React: React
};